import React from 'react'
import AppliedLogo from '../../static/applied_logo_master_gray.svg'
import LoginBlock from '../LoginBlock/LoginBlockContainer'
import LoggedInBlock from '../LoggedInBlock/LoggedInBlockContainer'

import styles from './HeaderBar.module.css'

class TextEditorPage extends React.Component {
    render() {
        return (
            <div className={styles.header}>
                <div className={styles.headerInner}>
                    <div className={styles.headerBlock}>
                        <img
                            src={AppliedLogo}
                            alt="Applied logo"
                            className={styles.image}
                        />
                        <h1 className={styles.headerText}>Job Description Analysis Tool</h1>
                    </div>
                    { this.props.user.userId ? <LoggedInBlock /> : <LoginBlock /> }
                </div>
            </div>
        )
    }
}

export default TextEditorPage
